<template>
  <!-- 首页五模块拼接入口 -->
  <div class="smy__box">
    <div class="smy__left">
      <!-- <FirstMenu /> -->
      <SecondMenu />
    </div>
    <div class="smy__right">
      <HeadNav />
      <HeadTags />
      <div class="smy__content">
        <transition :name="transitionName">
          <router-view class="router" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import FirstMenu from './FirstMenu'
import SecondMenu from './SecondMenu'
import HeadNav from './HeadNav'
import HeadTags from './HeadTags'
import { mapState, mapMutations, mapActions } from 'vuex'
import Error404 from './Error404'
import Error403 from './Error403'
import PersonIndex from './PersonIndex'

export default {
  components: {
    FirstMenu,
    SecondMenu,
    HeadNav,
    HeadTags,
    Error404,
    Error403,
    PersonIndex,
  },
  data() {
    return {
      transitionName: '',
      // 更新说明
      updateInfo: {},
      updateEditModal: false,
    }
  },
  computed: {
    ...mapState('menu', ['tag', 'thirdMenuList', 'allOrderKeyword']),
    // ...mapState('user', [
    //   'user',
    //   'isDisabledFunc',
    //   'versionMsg'
    // ])
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slider-right' : 'slider-left'
    },
    // 监听选中的标签，进行页面跳转
    tag(val) {
      if (val === '-1') {
        this.$router.push({ name: 'Index' })
      } else if (val === '-2' || val === -2) {
        this.$router.push({ name: 'Help' })
      } else {
        let tagName = val.split('-')
        this.thirdMenuList[tagName[0]].forEach((val) => {
          if (val.id === Number(tagName[1])) {
            if (val.routerName === 'AllOrder') {
              if (this.allOrderKeyword) {
                this.$router.push({
                  name: 'AllOrder',
                  query: { keyword: this.allOrderKeyword },
                })
                this._allOrderKeyword('')
              } else {
                let name =
                  val.routerName[0].toLowerCase() + val.routerName.substring(1)
                if (window.location.href.indexOf(name) === -1) {
                  this.$router.push({ name: val.routerName })
                }
              }
            } else {
              // let name =
              //   val.routerName[0].toLowerCase() + val.routerName.substring(1)
              // if (window.location.href.indexOf(name) === -1) {
              this.$router.push({ name: val.routerName })
              // }
            }
          }
        })
      }
    },
  },
  methods: {
    ...mapMutations('menu', ['_orderMenuList', '_allOrderKeyword']),
    ...mapMutations('table', ['_pageSizeOpts']),
    ...mapActions('menu', [
      '_FirstMenuList',
      '_SecondMenuList',
      '_ThirdMenuList',
    ]),
    ...mapMutations('user', ['_user', '_isDisabledFunc', '_versionMsg']),
  },
  created() {},
  beforeRouteEnter(to, from, next) {
    // axios.get('/menu/list').then((res) => {
    // if ( res.success) {
    // 预埋菜单权限

    let data = {
      firstList: [
        {
          id: 10,
          parent_id: 0,
          resource_name: 'ApplicationManagement',
          sort: 1,
        },
      ],
      secondList: [
        {
          id: 101,
          parent_id: 10,
          resource_name: 'ApplicationManagementList',
          sort: 1,
        },
        {
          id: 102,
          parent_id: 10,
          resource_name: 'MeiTuanSetting',
          sort: 2,
        },
        {
          id: 103,
          parent_id: 10,
          resource_name: 'DouYinSetting',
          sort: 3,
        },
      ],
      thirdList: [],
    }

    data.thirdList = data.thirdList.concat([
      {
        id: 201,
        parent_id: 101,
        resource_name: 'ApplicationManagementList1',
        sort: 1,
      },
      {
        id: 202,
        parent_id: 101,
        resource_name: 'trigger',
        sort: 2,
      },
      {
        id: 203,
        parent_id: 101,
        resource_name: 'globalVariable',
        sort: 3,
      },
      {
        id: 207,
        parent_id: 101,
        resource_name: 'Appointment',
        sort: 4,
      },
    ])

    data.thirdList = data.thirdList.concat([
      {
        id: 208,
        parent_id: 102,
        resource_name: 'MeiTuanSingleSet',
        sort: 1,
      },
      {
        id: 209,
        parent_id: 102,
        resource_name: 'MeiTuanSystemSetting',
        sort: 2,
      },
      { id: 210, parent_id: 102, resource_name: 'MeituanStore', sort: 3 },
      { id: 211, parent_id: 102, resource_name: 'MeituanAuth', sort: 4 },
    ])

    data.thirdList = data.thirdList.concat([
      {
        id: 210,
        parent_id: 103,
        resource_name: 'DouYinSKU',
        sort: 1,
      },
      {
        id: 211,
        parent_id: 103,
        resource_name: 'DouYinSystemSetting',
        sort: 2,
      },
      {
        id: 212,
        parent_id: 103,
        resource_name: 'DouYinProduct',
        sort: 3,
      },
      {
        id: 213,
        parent_id: 103,
        resource_name: 'DouYinStore',
        sort: 4,
      },
      {
        id: 214,
        parent_id: 103,
        resource_name: 'DouYinOrderList',
        sort: 5,
      },
      {
        id: 215,
        parent_id: 103,
        resource_name: 'DouYinAuth',
        sort: 5,
      },
    ])

    let menuList = data

    next((vm) => {
      vm._FirstMenuList(menuList)
    })
  },
}
</script>

<style lang="less">
@import '../assets/whole';
// tooltip气泡背景色
.ivu-tooltip {
  .ivu-tooltip-popper[x-placement^='bottom'] {
    .ivu-tooltip-inner {
      background-color: @tips-color;
    }
    .ivu-tooltip-arrow {
      border-bottom-color: @tips-color;
    }
  }
}
// poptip气泡阴影
.ivu-poptip-popper {
  .ivu-poptip-inner {
    box-shadow: 0 2px 10px rgba(153, 153, 153, 0.9);
  }
}
// 还原poptip气泡confirm阴影
.ivu-poptip-confirm {
  .ivu-poptip-inner {
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  }
}
// 气泡“我知道了” 放右边
.iKnowBtn {
  text-align: right;
}

.ivu-modal-wrap .ivu-modal {
  max-width: 100%;
  margin-bottom: 200px;
  top: 50px;
}
.visit-modal .ivu-modal-content .ivu-modal-body {
  padding-top: 0;
  padding-bottom: 0;
}

// 多选select选择器样式修复
.ivu-select-multiple .ivu-select-selection {
  white-space: nowrap;
  overflow-y: auto;
}
// ghost按钮中文字颜色
.ivu-btn-ghost,
.ivu-btn-default {
  color: #80848f;
}

// ghost按钮中文字hover颜色
.ivu-btn-ghost:hover,
.ivu-btn-default:hover {
  color: @primary-color;
}

// 工单视图poptip 去除内边距
.template-view .ivu-poptip-inner .ivu-poptip-body {
  padding: 0 0;
}

// 表单提示 自定义红星
.form-red-star {
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun;
  font-size: 12px;
  color: #ed3f14;
}

// 新手引导Tip
.smy__box {
  display: flex;
  height: 100%;

  .text-omit {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  //-------------组件样式重写-------------
  // 标签页的hover颜色
  .ivu-tabs-tab:hover {
    color: @primary-color;
  }

  // 莫名一条线
  .ivu-menu-vertical.ivu-menu-light:after {
    width: 0px;
  }
  // 修改tag圆点颜色
  .ivu-tag-green,
  .ivu-tag-green.ivu-tag-dot .ivu-tag-dot-inner {
    background-color: #3ccba6;
  }

  // 修改二级菜单的hover颜色
  .ivu-menu-submenu-title:hover,
  .ivu-menu-item:hover {
    background: #3ccba6;
  }

  // 修改二级菜单的上箭头边距
  .ivu-menu-submenu-title span i:last-child {
    margin-right: 0;
  }

  // 版本用量页面进度条色值修改
  .version-dosage {
    .ivu-progress-success {
      .ivu-progress-outer {
        .ivu-progress-inner {
          .ivu-progress-bg {
            background-color: #3ccba6;
          }
        }
      }
    }
  }

  // error按钮中文字颜色
  .ivu-btn-error {
    background: transparent;
    color: #80848f;
    border-color: #dddee1;
  }

  // error按钮中文字hover颜色
  .ivu-btn-error:hover {
    background: transparent;
    color: #f2795b;
    border-color: #f2795b;
  }

  .ivu-card-body {
    display: flex;
    flex: 1;
    flex-direction: column;
  }
  //-------------组件样式重写结束-------------

  // 字体超出省略
  .smy__text-overflow-one-line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .smy__left {
    display: flex;
    height: 100%;
  }

  .smy__right {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .smy__content {
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      overflow-x: hidden;
      position: relative;

      .smy__card-full-box {
        padding: 10px;
        height: 100%;
      }

      .smy__card-full {
        margin-bottom: 10px;
        min-height: 100%;

        .extra {
          font-size: 12px;
          color: #80848f;
        }
      }
      .extra {
        font-size: 12px;
        color: #80848f;
      }
      // ---路由切换动效---
      .router {
        position: absolute;
        width: 100%;
        height: 100%;
        transition: all 0.5s ease;
        -webkit-transition: all 0.5s ease;
      }

      .slider-parent {
        position: relative;
      }

      .slider {
        transition: all 0.5s ease;
        -webkit-transition: all 0.5s ease;
        position: absolute;
      }

      .slider-enter-left-active,
      .slider-left-leave-active {
        transition: all 0.3s;
        -webkit-transition: all 0.3s;
      }
      .slider-left-enter,
      .slider-left-leave-active {
        opacity: 0;
      }
      .slider-left-enter {
        transform: translateX(20px);
      }
      .slider-left-leave-active {
        transform: translateX(-20px);
      }

      .slider-enter-right-active,
      .slider-right-leave-active {
        transition: all 0.3s;
        -webkit-transition: all 0.3s;
      }
      .slider-right-enter,
      .slider-right-leave-active {
        opacity: 0;
      }
      .slider-right-enter {
        transform: translateX(-20px);
      }
      .slider-right-leave-active {
        transform: translateX(20px);
      }
      // ---路由切换动效 结束---
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue